module.exports = san.defineComponent({
    template: require('../views/qjzxSelect.html'),
    initData: function () {
        return {
            showCompany: false
        };
    },
    components: {

    },
    created: function () {

    },
    showCompany: function () {
        this.data.set('showCompany', true);
    },
    goLc: function (t, id, title) {
        if (t) {
            var obj = {
                t: t,
                id: id,
                title: title
            };
            this.dispatch('getAskType', obj);
            var model, visitModel, visitModelName;
            switch (t) {
                case '1':
                    model = "SCENE_CONSULT-JTSG";
                    break;
                case '2':
                    model = "SCENE_CONSULT-HYJT";
                    break;
                case '3':
                    model = "SCENE_CONSULT-LDZY";
                    break;
                case '4':
                    model = "SCENE_CONSULT-CPZL";
                    break;
                case '5':
                    model = "SCENE_CONSULT-QQJF";
                    break;
                case '6':
                    model = "SCENE_CONSULT-FCMM";
                    break;
                case '7':
                    model = "SCENE_CONSULT-MJJD";
                    break;
                case '8':
                    model = "SCENE_CONSULT-MMHT";
                    break;
                case '9':
                    model = "SCENE_CONSULT-GSCS";
                    break;
                default:
                    model = "SCENE_CONSULT";
            }
            switch (id) {
                case '101':
                    visitModel = "SCENE_CONSULT-JTSG-SFPCZR";
                    visitModelName = "情景咨询-交通事故-谁负赔偿责任";
                    break;
                case '201':
                    visitModel = "SCENE_CONSULT-HYJT-LHDTJ";
                    visitModelName = "情景咨询-婚姻家庭-离婚的条件";
                    break;
                case '202':
                    visitModel = "SCENE_CONSULT-HYJT-LHZNFYF";
                    visitModelName = "情景咨询-婚姻家庭-离婚子女抚养费";
                    break;
                case '203':
                    visitModel = "SCENE_CONSULT-HYJT-LHZNFYQ";
                    visitModelName = "情景咨询-婚姻家庭-离婚子女抚养权";
                    break;
                case '204':
                    visitModel = "SCENE_CONSULT-HYJT-YCYSJC";
                    visitModelName = "情景咨询-婚姻家庭-遗产由谁继承";
                    break;
                case '205':
                    visitModel = "SCENE_CONSULT-HYJT-FQGTZWRD";
                    visitModelName = "情景咨询-婚姻家庭-夫妻共同债务认定";
                    break;
                case '206':
                    visitModel = "SCENE_CONSULT-HYJT-LHFCFG";
                    visitModelName = "情景咨询-婚姻家庭-离婚房产分割";
                    break;
                case '301':
                    visitModel = "SCENE_CONSULT-LDZY-SBSLDGX";
                    visitModelName = "情景咨询-劳动争议-是不是劳动关系";
                    break;
                case '302':
                    visitModel = "SCENE_CONSULT-LDZY-SBGZJF";
                    visitModelName = "情景咨询-劳动争议-双倍工资纠纷";
                    break;
                case '303':
                    visitModel = "SCENE_CONSULT-LDZY-JJBCJF";
                    visitModelName = "情景咨询-劳动争议-经济补偿纠纷";
                    break;
                case '304':
                    visitModel = "SCENE_CONSULT-LDZY-LDBCJF";
                    visitModelName = "情景咨询-劳动争议-劳动报酬纠纷";
                    break;
                case '305':
                    visitModel = "SCENE_CONSULT-LDZY-GSRDZY";
                    visitModelName = "情景咨询-劳动争议-工伤认定争议";
                    break;
                case '306':
                    visitModel = "SCENE_CONSULT-LDZY-SHBXJF";
                    visitModelName = "情景咨询-劳动争议-社会保险纠纷";
                    break;
                case '307':
                    visitModel = "SCENE_CONSULT-LDZY-SYQJF";
                    visitModelName = "情景咨询-劳动争议-试用期纠纷";
                    break;
                case '308':
                    visitModel = "SCENE_CONSULT-LDZY-WYJJF";
                    visitModelName = "情景咨询-劳动争议-违约金纠纷";
                    break;
                case '401':
                    visitModel = "SCENE_CONSULT-CPZL-CPZL";
                    visitModelName = "情景咨询-产品质量-产品质量";
                    break;
                case '501':
                    visitModel = "SCENE_CONSULT-QQJF-GYQQ";
                    visitModelName = "情景咨询-侵权纠纷-雇佣侵权";
                    break;
                case '601':
                    visitModel = "SCENE_CONSULT-FCMM-RGSWT";
                    visitModelName = "情景咨询-房产买卖-认购书问题";
                    break;
                case '602':
                    visitModel = "SCENE_CONSULT-FCMM-YFEMWT";
                    visitModelName = "情景咨询-房产买卖-一房二卖问题";
                    break;
                case '603':
                    visitModel = "SCENE_CONSULT-FCMM-MJWC";
                    visitModelName = "情景咨询-房产买卖-面积误差";
                    break;
                case '604':
                    visitModel = "SCENE_CONSULT-FCMM-YQBZ";
                    visitModelName = "情景咨询-房产买卖-逾期办证";
                    break;
                case '605':
                    visitModel = "SCENE_CONSULT-FCMM-YQJF";
                    visitModelName = "情景咨询-房产买卖-逾期交房";
                    break;
                case '701':
                    visitModel = "SCENE_CONSULT-MJJD-HKJF";
                    visitModelName = "情景咨询-民间借贷-还款纠纷";
                    break;
                case '801':
                    visitModel = "SCENE_CONSULT-MMHT-HWMMHTJF";
                    visitModelName = "情景咨询-买卖合同-货物买卖合同纠纷";
                    break;
                case '901':
                    visitModel = "SCENE_CONSULT-GSCS-GSSLGCZDMSZRCD";
                    visitModelName = "情景咨询-公司财税-公司设立过程中的民事责任承担";
                    break;
                default:
                  visitModel = "";
                  visitModelName = "";
            }
            if (!!model && !!visitModel && !!visitModelName) {
                window.NewLog._saveLog(model, "", visitModel, visitModelName, "ASK");
            }
        }
    },
    messages: {

    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/qjzxSelect.js
// module id = 359
// module chunks = 1